<script setup>
import Detail   from '@/components/media/MediaDetail.vue';
import Load   from '@/components/common/Load.vue';
import Alert   from '@/components/common/Alert.vue';
import axios  from "axios";
import moment  from "moment";
import { saveAs } from 'file-saver';
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-card
    flat
    tile
    style="margin:0 auto"
>
    <v-card-text>
        <v-card>
        <v-card-text
            style="background-color:#F2F2F2"
        >
    <v-row>
        <v-col cols="8">
        <v-text-field
            v-model="search_word"
            clearable
            hide-details="auto"
            dense
            placeholder="メディア名やURLで検索できます。"
            outlined
            @input="searchInput()"
        ></v-text-field>
        </v-col>
        <v-col class="pt-0">
            <v-select
                :items="category_list"
                v-model="cat_id"
                item-text="label"
                item-value="id"
                class="pt-2"
                label="分類"
                clearable
            >
            </v-select>
        </v-col>
    </v-row>
    <v-row>
        <v-col class="pt-0">
            <v-select
                :items="tag_list"
                v-model="tag"
                class="pt-2"
                label="タグ"
                multiple
                chips
                clearable
            >
            </v-select>
        </v-col>
    </v-row>
    <v-row>
        <v-col class="py-0 pr-0" cols="5">
    <dl class="form__set -auto">
     <dt class="form__title">
      <span class="form__title-text">記事数</span>
     </dt>
     <dd class="form__contents">
      <fieldset class="form__check-box">
       <ul class="input-list" v-cloak>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputScal[0].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>大</span>
         </label>
        </li>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputScal[1].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>中</span>
         </label>
        </li>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputScal[2].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>小</span>
         </label>
        </li>
       </ul>
      </fieldset>
     </dd>
    </dl>
        </v-col>
        <v-col class="py-0 px-0">
    <dl class="form__set -auto">
     <dt class="form__title">
      <span class="form__title-text">ポスト</span>
     </dt>
     <dd class="form__contents">
      <fieldset class="form__check-box">
       <ul class="input-list" v-cloak>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputTweet[0].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>されやすい</span>
         </label>
        </li>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputTweet[1].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>される</span>
         </label>
        </li>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputTweet[2].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>されにくい</span>
         </label>
        </li>
       </ul>
      </fieldset>
     </dd>
    </dl>

        </v-col>
    </v-row>
    <v-row>
        <v-col class="py-0 pr-0" cols="7">
    <dl class="form__set -auto">
     <dt class="form__title">
      <span class="form__title-text">閲覧数</span>
     </dt>
     <dd class="form__contents">
      <fieldset class="form__check-box">
       <ul class="input-list" v-cloak>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputPV[2].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>多い</span>
         </label>
        </li>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputPV[1].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>普通</span>
         </label>
        </li>
        <li class="input-list__item">
         <label class="form__label -check" id="emo_func">
          <input type="checkbox" name="emotion1" class="form__check"  id="emo1" value="1" v-on:change="view_list()" v-model="inputPV[0].checked">
          <span class="form__check-text" ><i class="form__check-faker" ></i>少ない</span>
         </label>
        </li>
       </ul>
      </fieldset>
     </dd>
    </dl>
        </v-col>
        <v-col class="py-0 px-0">
            <dl class="form__set -auto">
             <dt class="form__title">
              <span class="form__title-text">絞る</span>
             </dt>
              <dd class="form__contents">
              <fieldset class="form__check-box">
               <ul class="input-list" v-cloak>
                <li class="input-list__item">
                 <label class="form__label -check" id="emo_func">
                  <input type="checkbox" name="tw" class="form__check" v-model="rel_addressee" v-on:change="view_list()">
                  <span class="form__check-text" ><i class="form__check-faker" ></i>リリース宛先</span>
                 </label>
                </li>
                <li class="input-list__item">
                 <label class="form__label -check" id="emo_func">
                  <input type="checkbox" name="tw" class="form__check"  id="tw" value="1" v-model="imp_flg.checked" v-on:change="view_list()">
                  <span class="form__check-text" ><i class="form__check-faker" ></i>重要</span>
                 </label>
                </li>
                </ul>
              </fieldset>
             </dd>
            </dl>
        </v-col>
    </v-row>
				<v-row>
					<v-col>
					<v-icon
						@click="download"
					>
						mdi-download
					</v-icon>
					</v-col>
				</v-row>
            </v-card-text>
        </v-card>
    </v-card-text>
    <v-card-text class="pt-0">
    <div class="rel_control">
        <div class="rel_message">
		リリース宛先があるものはリスト候補ボタンを押下するとメディアリスト候補へ登録できます。メディアリスト機能でリスト候補を編集してください。<v-icon>mdi-plus</v-icon>を押下すると個別にリスト候補へ登録できます。
        <span class="media_attension">プレスリリース受付窓口：<img src="rel_image/fax.svg" >・Faxで受付<img src="rel_image/zip.svg" >・郵送で受付<img src="rel_image/mail.svg" >・メールで受付<img src="rel_image/site.svg" >・受付フォーム有</span>
        </div>
    </div>
    <div v-if="load_flg==true && media_list.length>0">
    <v-pagination
      v-model="page"
      :length="len"
      :total-visible="7"
      circle
      v-if="len > 1"
      @input="input"
      @prev="prev"
      @next="next"
    ></v-pagination>

    <v-list style="justify-contents:center;">
        <v-list-item class="media_list_item" v-for="result,index in media_list" :key="index">
            <Detail :result="result" v-on:refresh="refr" />
        </v-list-item>
    </v-list>
    <v-pagination
      v-model="page"
      :length="len"
      :total-visible="7"
      circle
      v-if="len > 1"
      @input="input"
      @prev="prev"
      @next="next"
    ></v-pagination>
    </div>
    <Alert
        messagetitle="指定条件のメディア情報は登録されていません"
        message="条件を見直してもう一度検索してください。"
        messagetype="0"
        blockheight="500px"
        v-else-if="load_flg==true && media_list.length==0"
    />
    <Load v-else />
    </v-card-text>
</v-card>
</template>
<script>
export default {
   computed : {
        _query (){
            return [this.cat_id,this.tag];
        },
    },
    watch : {
        project_obj : function(){
            this.view_list();
        },
        _query : function(){
            this.searchInput();
        },
    },
    data : function(){
        return {
            page     : 1,
            len      : 1,
            max_len  : 20,
            rel_addressee : "",
            disp_flg    : false,
            project_obj : null,
            search_word : "",
            cat_id : "",
            tag : "",
            reprint_site : [],
            category_list : [],
            tag_list : [],
            media_list : [],
            pfm_flg: {},
            imp_flg: {},
            scl_str : "",
            twt_str :"",
            pv_str : "",
            load_flg : false,
            timeout  : null,
           inputScal: [{ checked : true , value : 'dn.dv >= 60'}
                    ,{ checked : true , value :  'dn.dv >= 50 and dn.dv < 60'}
                    ,{ checked : true , value :  'dn.dv < 50'}],
           inputTweet: [{ checked : true , value : 'tn.dv >= 60'}
                    ,{ checked : true , value :  'tn.dv >= 50 and tn.dv < 60'}
                    ,{ checked : true , value :  'tn.dv < 50'}],

           inputPV: [{ checked : true , value : 'sm.user_num <= 47'}
                    ,{ checked : true , value :  'sm.user_num <= 50 and sm.user_num > 47'}
                    ,{ checked : true , value :  'sm.user_num > 50'}],

        };
    },
    methods : {
        searchInput : function (){
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.view_list();
            }, 1000);
        },
        input        : function(data){
            this.page = data;
            this.media_list = [];
            this.view_list(1);
        },
        prev         : function(){
            this.media_list = [];
            this.view_list(1);
        },
        next         : function(){
            this.media_list = [];
            this.view_list(1);
        },
        refr : function(){
            this.view_list(1);
        },
        project_search : function(data){
            this.project_obj  = data;
        },
		create_query : function(){
            let params = new URLSearchParams();
            if(this.project_obj != null)
            {
                params.append('group_id',this.project_obj.group_id);
                if(this.project_obj.cats != undefined)
                {
                    params.append('cats',this.project_obj.cats);
                }
                if(this.project_obj.inc != undefined)
                {
                    params.append('inc',this.project_obj.inc);
                }
                else
                {
                    params.append('inc',1);
                }
            }
            if(this.cat_id != "" && this.cat_id != null )
            {   
                params.append('cat_id', this.cat_id);
            }
            if(this.tag != "" && this.tag!=null)
            {   
                params.append('tag', this.tag);
            }

            if (this.rel_addressee == true)
            {   
                params.append('rel_addressee', true);
            }

            let scl_str = this.TrueScaleList();
            if(scl_str != "")
            {   
                params.append('true_scl', scl_str);
            }
            if(this.pfm_flg.checked == true)
            {   
                params.append('pfm', true);
            }
            if(this.imp_flg.checked == true)
            {   
                params.append('imp', true);
            }
            let twt_str = this.TrueTweetList();
            if(twt_str != "")
            {
                params.append('true_twt', twt_str);
            }

            let pv_str = this.TruePVList();
            if(pv_str != "")
            {
                params.append('true_pv', pv_str);
            }

            if(this.comp_flg == true)
            {
                params.append('comp', true);
            }

            if(this.search_word != "" && this.search_word != null)
            {
                params.append('search_word', this.search_word);
            }
			return params;

		},
		download  : async function(){
			let params = this.create_query();
            await axios.post("/api/media/get_media_ana_download",params,{responseType: "blob"})
            .then(response => {
                const blob = new Blob([response.data], {
                    type: response.data.type
                });
                saveAs(blob, "media_download-"+moment().format('YYYY-MM-DD')+".csv");
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
		},
        view_list : function (flg=0) {
            if(flg!=1)
                this.page=1;
            this.page_num = this.page;
			let params = this.create_query();
            params.append('p', this.page_num);
            this.load_flg = false;

            this.media_list = [];
            axios.post("/api/media/get_media_summary",params)
            .then(response => {
                this.count = response.data['cnt'];
                this.load_flg = true;
                if(response.data['list'].length==0)
                {
                    this.media_list = [];
                    this.len = 0;
                    return;
                }
                this.media_list = response.data['list'];
                let cnt = response.data['cnt'];
                this.len = Math.ceil( Number(cnt) / this.max_len  );
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        TrueScaleList : function (){
            let scl_string = "";
            for(let i = 0 ; i < this.inputScal.length ; i++)
            {
                if(this.inputScal[i].checked)
                {
                    if(scl_string != '')
                        scl_string += ",";
                    scl_string += this.inputScal[i].value;
                }
            }
            this.scl_str = scl_string;
            return scl_string;
        },
        TrueTweetList : function (){
            var twt_string = "";
            for(let i = 0 ; i < this.inputTweet.length ; i++)
            {
                if(this.inputTweet[i].checked)
                {
                    if(twt_string != '')
                        twt_string += ",";
                    twt_string += this.inputTweet[i].value;
                }
            }
            this.twt_str = twt_string;
            return twt_string;
        },
        TruePVList : function (){
            var pv_string = "";
            for(let i = 0 ; i < this.inputPV.length ; i++)
            {
                if(this.inputPV[i].checked)
                {
                    if(pv_string != '')
                        pv_string += ",";
                    pv_string += this.inputPV[i].value;
                }
            }
            this.pv_str = pv_string;
            return pv_string;
        },
        category_get: function (){
            axios.get("/api/media/get_category.php")
                .then(response => {
                for(let i = 0 ;response.data.length>i ; i++)
                {
                    if(response.data[i].label!="")
                        this.category_list.push(response.data[i]);
                }
            }).catch((error) => {
                //window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        tag_get: function (){
            axios.get("/api/media/get_tag.php")
                .then(response => {
                this.tag_list = [];
                for( let i = 0 ; i < response.data.length ; i++)
                {
                    if(response.data[i].tag!="")
                        this.tag_list.push(response.data[i]['tag']);
                }
            }).catch((error) => {
                //window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
    created : function(){
        this.view_list();
        this.category_get();
        this.tag_get();
    },
}
</script>
